
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.013 1.333a6.644 6.644 0 014.593 1.846l.96-.96a.645.645 0 011.101.457v3.603a.645.645 0 01-.645.645h-3.604a.645.645 0 01-.456-1.101l1.123-1.122A4.483 4.483 0 008.04 3.484c-2.484-.022-4.578 1.988-4.556 4.555.02 2.434 1.994 4.477 4.516 4.477 1.105 0 2.15-.395 2.974-1.117a.322.322 0 01.44.015l1.066 1.066a.323.323 0 01-.013.468A6.667 6.667 0 011.334 8c0-3.677 3.001-6.673 6.679-6.666z","fill":"#348EF6"}})])
          )
        }
      }
    